import type { SupporterVoice } from '#src/app/pages/actions/shared/types';

import type { PetitionActionsPageState } from './types';

export const mutations = {
	addSupporterVoice: (state: PetitionActionsPageState, supporterVoice: SupporterVoice): PetitionActionsPageState => ({
		...state,
		supporterVoices: [...state.supporterVoices, supporterVoice],
	}),
	updateSupporterVoice: (
		state: PetitionActionsPageState,
		supporterVoice: SupporterVoice,
	): PetitionActionsPageState => ({
		...state,
		supporterVoices: state.supporterVoices.map((candidate) => {
			if (candidate.id === supporterVoice.id) {
				return supporterVoice;
			}
			return candidate;
		}),
	}),
	setLastSupporterVoicesPage: (
		state: PetitionActionsPageState,
		isLastSupporterVoicesPage: boolean,
	): PetitionActionsPageState => ({
		...state,
		isLastSupporterVoicesPage,
	}),
	setEndCursor: (state: PetitionActionsPageState, endCursor: string | undefined): PetitionActionsPageState => ({
		...state,
		endCursor,
	}),
	setLoadingMoreSupporterVoices: (
		state: PetitionActionsPageState,
		isLoadingMoreSupporterVoices: boolean,
	): PetitionActionsPageState => ({
		...state,
		isLoadingMoreSupporterVoices,
	}),
	setShareSupporterVoiceError: (
		state: PetitionActionsPageState,
		shareSupporterVoiceError: string | undefined,
	): PetitionActionsPageState => ({
		...state,
		shareSupporterVoiceError,
	}),
	setShareSupporterVoiceSuccess: (
		state: PetitionActionsPageState,
		shareSupporterVoiceSuccess: boolean,
	): PetitionActionsPageState => ({
		...state,
		shareSupporterVoiceSuccess,
	}),
	setLikeError: (state: PetitionActionsPageState, supporterVoiceId: string): PetitionActionsPageState => {
		const { likeErrors } = state;
		likeErrors[supporterVoiceId] = true;
		return {
			...state,
			likeErrors,
		};
	},
	setNewSupporterVoiceId: (
		state: PetitionActionsPageState,
		newSupporterVoiceId: string | undefined,
	): PetitionActionsPageState => ({
		...state,
		newSupporterVoiceId,
	}),
	unsetLikeError: (state: PetitionActionsPageState, supporterVoiceId: string): PetitionActionsPageState => {
		const { likeErrors } = state;
		likeErrors[supporterVoiceId] = false;
		return {
			...state,
			likeErrors,
		};
	},
	setUnlikeError: (state: PetitionActionsPageState, supporterVoiceId: string): PetitionActionsPageState => {
		const { unlikeErrors } = state;
		unlikeErrors[supporterVoiceId] = true;
		return {
			...state,
			unlikeErrors,
		};
	},
	unsetUnlikeError: (state: PetitionActionsPageState, supporterVoiceId: string): PetitionActionsPageState => {
		const { unlikeErrors } = state;
		unlikeErrors[supporterVoiceId] = false;
		return {
			...state,
			unlikeErrors,
		};
	},
	setShouldDisplaySupporterVoicesVideo: (
		state: PetitionActionsPageState,
		shouldDisplaySupporterVoicesVideo: boolean,
	): PetitionActionsPageState => ({
		...state,
		shouldDisplaySupporterVoicesVideo,
	}),
};
